import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { getClassificationBannerInfo } from "state/auth/selectors";
import { white, black } from "utils/constants/colors";

const ClassificationBannerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background: ${(props) => props.backgroundColor || white};
  color: ${(props) => props.textColor || black};
  padding: 10px 0;
`;

function ClassificationBanner({ classificationBannerData }) {
  if (!classificationBannerData?.message) {
    return null;
  }

  return (
    <ClassificationBannerWrap
      backgroundColor={classificationBannerData.bannerColor}
      textColor={classificationBannerData.textColor}
    >
      {classificationBannerData.message}
    </ClassificationBannerWrap>
  );
}
export default connect((state) => ({
  classificationBannerData: getClassificationBannerInfo(state),
}))(ClassificationBanner);
